import * as moment from 'moment';
import { IWatrRequestTravels } from '@nkr/models/watr-request-travels'
import { FileDocumentType } from '@nkr/enums/document-type';
import { useState, useContext, useEffect } from 'react';
import { WageAndTravelReimbursementRequestStatus } from '@nkr/enums/watr-reimbursement-request-status';
import { Utility } from '@nkr/services/utility';
import { Button, Panel } from 'react-bootstrap';
import { getTripPhaseName } from './verify/constants/trip-phases';
import { DonorShieldContext } from './context';
import { IWatrLineItem } from '@nkr/models/watr-request-travels';

export interface IProps {
    data: IWatrRequestTravels,
    downloadFile: (docType: FileDocumentType, lookupId: number) => void
}

const TravelReimbursementRecord = (props: IProps) => {
    const [show, setShow] = useState(false);

    if (props.data == null) {
        return <></>
    }

    return (
        <>
            <Panel expanded={show}>
                <Panel.Heading>
                    <Panel.Title toggle>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <div>
                                {[WageAndTravelReimbursementRequestStatus.AdminDeclined, WageAndTravelReimbursementRequestStatus.CenterDeclined].includes(props.data.status) && <span style={{ color: 'red' }}>{'(Declined) '}</span>}
                                <strong>
                                    Expense Reimbursement Requested {Utility.getOrdinalSuffixOfDate(props.data.createdDateTime)}
                                </strong>
                            </div>
                            <div>
                                <Button bsStyle='info' onClick={() => setShow(!show)}>{show ? 'Hide' : 'Show'}</Button>
                            </div>
                        </div>
                    </Panel.Title>
                </Panel.Heading>
                <Panel.Collapse>
                    <Panel.Body>
                        {props.data.trips && props.data.trips.length > 0 && (
                            (() => {
                                const sortedTrips = props.data.trips.sort((a, b) => {
                                    const dateA = a.tripDate ? moment(a.tripDate).valueOf() : 0;
                                    const dateB = b.tripDate ? moment(b.tripDate).valueOf() : 0;
                                    return dateA - dateB;
                                });
                                return (
                                    <table className='table table-condensed table-nkr-styled' style={{ width: '100%' }}>
                                        <thead>
                                            <tr>
                                                <th>Trip</th>
                                                <th>Date</th>
                                                <th>Reason</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {sortedTrips.map((trip, index) =>
                                                <tr key={trip.id || index}>
                                                    <td>{index + 1}</td>
                                                    <td>{trip.tripDate ? moment(trip.tripDate).format('MM/DD/YYYY') : '-'}</td>
                                                    <td>{getTripPhaseName(trip)}</td>
                                                </tr>
                                            )}
                                            <tr>
                                                <td colSpan={3}>&nbsp;</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                );
                            })()
                        )}

                        <table className='table table-condensed table-nkr' style={{ width: '100%' }}>
                            <thead>
                                <tr>
                                    <th style={{ textAlign: 'left' }}>
                                        {/* {[WageAndTravelReimbursementRequestStatus.AdminDeclined, WageAndTravelReimbursementRequestStatus.CenterDeclined].includes(props.data.status) && <span style={{ color: 'red' }}>{'(Declined) '}</span>}
                                        Expense Reimbursement Requested {Utility.getOrdinalSuffixOfDate(props.data.createdDateTime)} */}
                                    </th>
                                    <th style={{ textAlign: 'right' }}>Amount</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td style={{ textAlign: 'left' }}><strong>Mileage Total:</strong></td>
                                    <td style={{ textAlign: 'right' }}>
                                        {'$' + (props.data.trips || []).reduce((total, trip) => {
                                            const tripLineItems = (trip as any).lineItems || (props.data.lineItems || []).filter((li: IWatrLineItem) => li.tripId === trip.id);
                                            const tripAmount = tripLineItems.reduce((sum: number, li: IWatrLineItem) => sum + (li.amount || 0), 0);
                                            return total + tripAmount;
                                        }, 0).toLocaleString('en-us', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ textAlign: 'left' }}><strong>Lodging Expenses:</strong></td>
                                    <td style={{ textAlign: 'right' }}>${props.data.hotelLodgingExpense == undefined ? '0.00' : props.data.hotelLodgingExpense.toLocaleString('en-us', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                                </tr>
                                <tr>
                                    <td style={{ textAlign: 'left' }}><strong>Flight/Train Expenses:</strong></td>
                                    <td style={{ textAlign: 'right' }}>${props.data.flightAndTrainExpense == undefined ? '0.00' : props.data.flightAndTrainExpense.toLocaleString('en-us', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                                </tr>
                                <tr>
                                    <td style={{ textAlign: 'left' }}><strong>Transportation Expense:</strong></td>
                                    <td style={{ textAlign: 'right' }}>${props.data.carServiceExpense == undefined ? '0.00' : props.data.carServiceExpense.toLocaleString('en-us', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr>
                                    <td style={{ backgroundColor: '#DDD', textAlign: 'left' }}><strong>Receipts Total:</strong></td>
                                    <td style={{ textAlign: 'right', backgroundColor: '#DDD' }}>${props.data.travelReceiptsTotal.toLocaleString('en-us', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                                </tr>
                                <tr>
                                    <td style={{ backgroundColor: '#FFC', textAlign: 'left' }}><strong>Total Reimbursement:</strong></td>
                                    <td style={{ textAlign: 'right', backgroundColor: '#FFC' }}>${props.data.travelReimbursementTotal.toLocaleString('en-us', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                                </tr>
                            </tfoot>
                        </table>
                    </Panel.Body>
                </Panel.Collapse>
            </Panel>
        </>
    )
}

export default TravelReimbursementRecord;